import { API_VERSIONS, asinzenAdminApi } from "client/api";

export const getVersions = () =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .get(`/${API_VERSIONS}/admin/versions/get-versions`);

export const notifyUsers = (params: any) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .post(`/${API_VERSIONS}/admin/versions/notify-users`, params);

export const switchCrawler = (params: any) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .post(`/${API_VERSIONS}/admin/versions/enable_crawler`, params)

export const updateToolVersion = (params: any) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .post(`/${API_VERSIONS}/admin/versions/update`, params)